import { forwardRef } from "react";

export const LinkIcon = forwardRef<
    SVGSVGElement,
    React.SVGProps<SVGSVGElement>
>((props, ref) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 20 20"
        fill="none"
        {...props}
        ref={ref}
    >
        <path
            d="M11.4221 8.57789C10.2071 7.36293 8.2373 7.36293 7.02233 8.57789L3.91122 11.689C2.69626 12.904 2.69626 14.8738 3.91122 16.0888C5.12619 17.3037 7.09603 17.3037 8.311 16.0888L9.16777 15.232M8.57789 11.4221C9.79285 12.6371 11.7627 12.6371 12.9777 11.4221L16.0888 8.311C17.3037 7.09603 17.3037 5.12619 16.0888 3.91122C14.8738 2.69626 12.904 2.69626 11.689 3.91122L10.8337 4.76648"
            stroke="#D4D4D4"
            strokeWidth="1.67"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
));

LinkIcon.displayName = "LinkIcon";
